import { LocationArea } from 'components/SearchSideBar/BasicInfo/LocationArea';
import { OccupationArea } from 'components/SearchSideBar/BasicInfo/OccupationArea';
import {
  LocationType,
  OccupationType,
  RouteStationType,
} from 'components/SearchSideBar/BasicInfo/types';
import { SidebarSection } from 'components/SearchSideBar/SidebarSection';
import { UpdateJobCountType } from 'components/SearchSideBar/types';
import { FC, memo } from 'react';

/**
 * BasicInfoコンポーネントのプロパティを定義するインターフェース
 */
interface Props {
  conditions: {
    occupation: OccupationType;
    location: LocationType;
    routeStation: RouteStationType;
  };
  modalAction: {
    onOpenOccupationModal: () => void;
    onOpenLocationModal: () => void;
    onOpenRouteModal: () => void;
  };
  getJobCountAtModalDisplay: {
    getJobCountWithoutOccupation: () => Promise<void>;
    getJobCountWithoutLocationAndStation: () => Promise<void>;
  };
  updateJobCount: UpdateJobCountType;
  onChangeIsShowOverlay: () => void;
}

/**
 * BasicInfoコンポーネント
 *
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element} JSX要素
 */
export const BasicInfo: FC<Props> = memo(
  ({
    conditions,
    modalAction,
    getJobCountAtModalDisplay,
    updateJobCount,
    onChangeIsShowOverlay,
  }) => {
    const { occupation, location, routeStation } = conditions;
    const { onOpenOccupationModal, onOpenLocationModal, onOpenRouteModal } =
      modalAction;
    const {
      getJobCountWithoutOccupation,
      getJobCountWithoutLocationAndStation,
    } = getJobCountAtModalDisplay;

    return (
      <SidebarSection title="基本条件">
        <OccupationArea
          occupation={occupation}
          updateJobCount={updateJobCount}
          onChangeIsShowOverlay={onChangeIsShowOverlay}
          onClickOpenModal={() => {
            getJobCountWithoutOccupation();
            onOpenOccupationModal();
          }}
        />
        <LocationArea
          location={location}
          routeStation={routeStation}
          updateJobCount={updateJobCount}
          onClickOpenLocationModal={() => {
            getJobCountWithoutLocationAndStation();
            onOpenLocationModal();
          }}
          onClickOpenStationModal={() => {
            getJobCountWithoutLocationAndStation();
            onOpenRouteModal();
          }}
          onChangeIsShowOverlay={onChangeIsShowOverlay}
        />
      </SidebarSection>
    );
  }
);

BasicInfo.displayName = 'BasicInfo';
